function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { FIELD_TYPES } from "constants/template-field-type";
import SelectableTagsGridFieldsConfig from "segments/desktop/core-components/selectable-tags-grid/fields-config";
import CarouselFieldsConfig from "segments/desktop/core-components/carousel/fields-config";
import { ALIGN_TYPES, ALIGN_LABELS } from "constants/align-types";
export default {
    type: FIELD_TYPES.NESTED,
    label: "Tags With Carousel",
    fields: _object_spread({
        tagsAlign: {
            type: FIELD_TYPES.COMBO,
            label: "Tags Align",
            options: [
                {
                    value: ALIGN_TYPES.LEFT,
                    text: ALIGN_LABELS.LEFT
                },
                {
                    value: ALIGN_TYPES.CENTER,
                    text: ALIGN_LABELS.CENTER
                },
                {
                    value: ALIGN_TYPES.RIGHT,
                    text: ALIGN_LABELS.RIGHT
                }
            ]
        }
    }, CarouselFieldsConfig, SelectableTagsGridFieldsConfig)
};
